<template>
  <div class="add-todo todo-wrapper">
    <div class="add-todo__circle-elm"><button class="tic-circle" @click="onTicClick"></button></div>
    <input
      type="text" 
      class="add-todo__input" 
      @keydown.enter="inputValue"
      v-on:keydown.enter="emptyInput"
      ref="addInput"
      placeholder="Create a new todo..."
    />
  </div>
</template>

<script>
export default {
  name: "TheAddTodo",
  data() {
    return {
      inputText: ''
    }
  },
  methods: {
    emptyInput: function() {
      this.$refs.addInput.value = '';
    },
    inputValue: function($event) {
      this.$emit('onInputEnter', $event.target.value)
    },
    onTicClick: function() {
      this.$emit('onInputBtnClick', this.$refs.addInput.value)
      this.emptyInput();
    }
  },
}
</script>

<style>

:root {
  --todo-height: 64px;/* should be fluid */
}

.todo-wrapper {
    display: flex;
    align-items: center;
    height: var(--todo-height);
    width: 100%;
    background-color: var(--bg-todo-clr);
    border-radius: var(--border-radius);
    overflow: hidden;
}

.add-todo {
  margin-bottom: 30px;
}

.add-todo__circle-elm {
    display: flex;
    align-items: center;
    height: 100%;
    width: var(--todo-height);
}

.tic-circle {
    background-color: transparent;
    width: 37.5%;
    height: 37.5%;
    margin-left: 37.5%;
    border-radius: 50%;
    border: 1px solid var(--circle-border-clr);
    cursor: pointer;
}

.tic-circle:focus {
    outline: transparent;
    filter: brightness(160%);
}

.add-todo__input {
    --input-width: calc( 100% - var(--todo-height));
    height: 100%;
    width: var(--input-width);
    font-size: 1rem;
    border: none;
    outline: none; /* need to change */
    color: var(--todo-text-clr);
    background-color: inherit;
    text-indent: .5rem;
    text-overflow: ellipsis;
}

</style>